import { useGet2ndLevelPageUrl } from 'app-level/navigation';
import { CreateDeal, CreateDealVariables } from 'features/loanPool/__generated__/CreateDeal';
import { CREATE_DEAL_MUTATION } from 'features/loanPool/PoolHeader';
import { useNavigate } from 'react-router-dom';
import { styled } from 'style/ORSNNTheme';
import { Button, Dialog, useDialog } from 'ui-kit';

import { gql, useMutation } from '@apollo/client';

import { ListingSidebarListing } from './__generated__/ListingSidebarListing';

const ModalButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`;

const ListingSidebarFragments = {
  listing: gql`
    fragment ListingSidebarListing on Listing {
      id
      name
      in_progress_deal_id
      company {
        __typename
      }
    }
  `,
};

type ListingSidebarProps = {
  listing: ListingSidebarListing;
};

const PlainDiv = styled.div``;

const ListingSidebar = (props: ListingSidebarProps): JSX.Element => {
  const getUrl = useGet2ndLevelPageUrl();
  const [createDeal] = useMutation<CreateDeal, CreateDealVariables>(CREATE_DEAL_MUTATION);
  const navigate = useNavigate();

  const acceptDialog = useDialog();

  const needAccess =
    props.listing.company.__typename !== 'UserCompany' && !props.listing.in_progress_deal_id;

  const handleAccept = () => {
    acceptDialog.closeDialog();

    createDeal({ variables: { listingId: props.listing.id } }).then((response) => {
      const dealId = response.data?.createDeal.id;
      if (dealId) {
        navigate(getUrl('marketplace', 'deal'), { state: { dealId } });
      }
    });
  };

  return (
    <>
      {needAccess ? (
        <div className="sticky top-0 flex-[0_0_25%]">
          <Button
            type="secondary"
            size="medium"
            label="Create Offering"
            onClick={() => acceptDialog.openDialog()}
          >
            Request Access
          </Button>
        </div>
      ) : null}
      <Dialog dialog={acceptDialog} contentComponent={PlainDiv}>
        <div className="modal__container">
          <div className="modal__header_container">
            <div className="modal__header_text">Request Access</div>
            <div className="modal__header_subtext">ACCESS</div>
            <div className="modal__header_caption">
              By requesting access, you are asking the company for permission to access this
              offering. You will share your identity with the request.
            </div>
          </div>
          <div className="modal__body">
            <ModalButtonsContainer>
              <Button type="primary" label="Accept" onClick={handleAccept}>
                Accept
              </Button>
              <Button type="secondary" label="Decline" onClick={() => acceptDialog.closeDialog()}>
                Decline
              </Button>
            </ModalButtonsContainer>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default ListingSidebar;
export { ListingSidebarFragments };
